export default "<p>discount-dialog works!</p>\r\n";